<template>
    <div class="home view">
        <div class="container">
            <div class="logo"></div>
            <transition name="v-transition-pub">
                <ad v-if="showPub" :pubMsg="pubMsg" v-cloak></ad>
            </transition>
            <div class="no-connection" v-if="showConnectionAlert">
                Vous devez être connecté à internet pour mettre à jour votre agenda cet application
            </div>
        </div>
    </div>
</template>

<script>
    import Ad from './ad.vue';
    import Calendar from './calendar/Calendar.vue';
    import { eventBus } from './../main';

    export default {
        components: {
            ad: Ad,
            pubMsg: ""
        },
        data() {
            return {
                showPub: false,
            }
        },
        computed: {
            showConnectionAlert() {
                return !this.$store.state.isConnected;
            }
         },
        created() {
            //si le json a bien ete chargé et que tous les elements sont pret
            // on verifie la date actuelle et si besoin on affiche la pub
            let interval = setInterval( () => {
                if( this.$store.state.isReady === true ) {
                    if(this.$store.state.ad !== null) {
                        //affichage message pub
                        this.pubMsg = this.$store.state.ad.intro;

                        //affichage de la pub
                        setTimeout( () => {
                            this.showPub = true;
                            //deplacement du logo pour laisser la place à la pub
                            $('.logo').addClass('is-translated');
                        }, 1000)
                    }
                    clearInterval(interval);
                }

            }, 100);
        }
    }
</script>


// WEBPACK FOOTER //
// Home.vue?0afbcc9c